export default "__VITE_ASSET__DmIqCW1e__"